import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './UpdaterProgress.css';
import DeviceService from '../../apiclients/DeviceService';
class UpdateProgress extends Component {
    constructor(props) {
        super(props);
        this.state = {
            updateProgress: undefined,
        };

        document.onSynchronizerUpdate = this.onSynchronizerUpdate;
        this.timer = 0;
        // setInterval(() => document.onSynchronizerUpdate(Math.random()), 200);
        // FileDeliveryService.trackDevice('percentage').then(() => 1);
    }

    onSynchronizerUpdate = (percentage) => {
        // console.log('onSynchronizerUpdate', percentage);
        try {
            if (Math.round(this.state.updateProgress * 100) !== Math.round(percentage * 100)) {
                const p = percentage;
                clearTimeout(this.timer);
                this.timer = setTimeout(
                    () => DeviceService.trackDevice({ percentage: Math.round(p * 100), date: new Date().toISOString() }).then(() => 1),
                    100
                );
            }
        } catch (err) {
            console.log('UpdateProgress error', err);
        }
        this.setState({ updateProgress: percentage });
    };

    render() {
        if (this.state.updateProgress) {
            let val = this.state.updateProgress * 100;
            let size = this.props.size ? this.props.size : 200;
            let strokeWidth = size * 0.15;
            let radius = size / 2 - strokeWidth / 2;
            let perimeter = 2 * Math.PI * radius;

            if (val < 0) {
                val = 0;
            }
            if (val > 100) {
                val = 100;
            }
            let pct = ((100 - val) / 100) * perimeter;

            return (
                <div
                    className="pdc-updaterprogress-container"
                    style={{
                        height: `${size}px`,
                        width: `${size}px`,
                    }}
                >
                    <div
                        className="pdc-updaterprogress-percentage"
                        style={{
                            height: `${size - strokeWidth * 2}px`,
                            width: `${size - strokeWidth * 2}px`,
                            marginTop: `-${(size - strokeWidth * 2) / 2}px`,
                            marginLeft: `-${(size - strokeWidth * 2) / 2}px`,
                            lineHeight: `${size - strokeWidth * 2}px`,
                            fontSize: `${size / 6}px`,
                        }}
                    >
                        {Math.round(val * 10) / 10}
                        {'%'}
                    </div>
                    <svg width={size} height={size}>
                        <circle
                            r={radius}
                            cx={size / 2}
                            stroke="rgba(0, 0, 0, 0.5)"
                            strokeWidth={strokeWidth}
                            cy={size / 2}
                            fill="transparent"
                            strokeDasharray={perimeter}
                            strokeDashoffset="0"
                        />
                        <circle
                            r={radius}
                            cx={size / 2}
                            stroke={this.props.progressColor ? this.props.progressColor : '#efefef'}
                            strokeWidth={strokeWidth}
                            cy={size / 2}
                            fill="transparent"
                            strokeDasharray={perimeter}
                            strokeDashoffset={pct}
                            transform={`rotate(-90 ${size / 2} ${size / 2})`}
                        />
                    </svg>
                </div>
            );
        } else {
            return '';
        }
    }
}
UpdateProgress.propTypes = {
    // updateProgressValue: PropTypes.number,
    size: PropTypes.number.isRequired,
    progressColor: PropTypes.string,
};

export default UpdateProgress;
